import { Component } from '@angular/core';

@Component({
  selector: 'mobile-swipe-hint',
  templateUrl: 'mobile-swipe-hint.component.html',
  styleUrls: ['mobile-swipe-hint.component.scss'],
})
export class MobileSwipeHintComponent {

  constructor() { 
  }

}
